<template>
    <div class="loader-container" v-if="show">
        <span class="loader" :style="sizeStyle"></span>
        <span class="text" :style="textStyle">{{ text }}</span>
    </div>
</template>
<script>
export default {
    name: "Loader",
    props: {
        size: {
            type: Number,
            default: 100
        },
        show: {
            type: Boolean,
            default: true
        },
        text: {
            type: String,
            default: ""
        }
    },
    computed: {
        sizeStyle() {
            const borderSize = parseInt(this.size / 10);
            const beforeSize = this.size - (borderSize * 2);
            const afterSize = this.size - (borderSize * 4);
            return {
                '--loader-size': this.size + 'px',
                '--loader-before-size': beforeSize + 'px',
                '--loader-after-size': afterSize + 'px',
                '--loader-border-size': borderSize + 'px'
            }
        },
        textStyle() {
            return {
                '--loader-text-size': parseInt(this.size / 3) + 'px'
            }
        }
    }
}
</script>
<style scoped>
.loader-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    background-color: rgba(0, 0, 0, 0.5);
}

.text {
    color: #FFF;
    font-size: var(--loader-text-size);
    font-weight: bold;
    text-align: center;
}

.loader {
  width: var(--loader-size);
  height: var(--loader-size);
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: var(--loader-border-size) solid;
  border-color: #FFF #FFF transparent transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after,
.loader::before {
  content: '';  
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: var(--loader-border-size) solid;
  border-color: transparent transparent #FF3D00 #FF3D00;
  width: var(--loader-before-size);
  height: var(--loader-before-size);
  border-radius: 50%;
  box-sizing: border-box;
  animation: rotationBack 0.5s linear infinite;
  transform-origin: center center;
}
.loader::before {
  width: var(--loader-after-size);
  height: var(--loader-after-size);
  border-color: #FFF #FFF transparent transparent;
  animation: rotation 1.5s linear infinite;
}
    
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} 
@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>